<template>
  <v-card class="mobile-hazard-map-control pa-2">
    <div v-for="(usageItem, index) in hazardMapUsageGuide" :key="index">
      <div
        v-for="(ui, uiIndex) in usageItem"
        :key="`${index}_${uiIndex}`"
        class="mb-2"
      >
        <!-- title -->
        <div class="legend-title" v-if="ui.title">
          {{ ui.title }}
        </div>

        <!-- colors -->
        <div class="legend" v-if="ui.colors">
          <div
            v-for="(uiColor, index) in ui.colors"
            :key="index"
            style="display: flex; align-items: center;"
          >
            <v-card
              width="15"
              height="15"
              :color="uiColor.color"
              class="mr-2"
            ></v-card>
            <div>{{ uiColor.value }}</div>
          </div>
        </div>

        <!-- images -->
        <v-card class="legend" tile elevation="0" v-else-if="ui.images">
          <div
            style="height: 20px;"
            v-for="(uiImage, index) in ui.images"
            :key="index"
          >
            <div style="display: flex; align-items: center">
              <img :src="uiImage.url" height="16" width="16" class="mr-2" />
              <div>
                {{ uiImage.value }}
              </div>
            </div>
          </div>
        </v-card>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "MobileHazardMapControl",
  data() {
    return {
      //
    };
  },
  computed: {
    hazardMapUsageGuide() {
      return this.$store.getters.hazardMapUsageGuide;
    }
  },
  methods: {
    //
  }
};
</script>

<style scoped lang="scss">
.mobile-hazard-map-control {
  pointer-events: none;
  min-width: 150px;
  font-size: 11px;
  .legend-title {
    text-align: left;
    white-space: pre-wrap;
    line-height: 1.1;
    margin-bottom: 2px;
    text-decoration: underline;
  }
}
</style>
